<template>
  <Toast />
  <div class="surface-section px-2 py-2 md:px-12 lg:px-12">
    <div class="grid">
      <div class="field col-12 md:col-2 mt-3">
        <span class="especialidades-title">CONSULTORIOS</span>
        <div class="planta-baja mt-3">
          <ul class="list-none p-0 m-0 text-center">
            <li
              v-for="(consultorio, index) in consultorios"
              :key="index"
              class="consultorio-item"
            >
              <span
                @click="mostrarAgenda(consultorio.id, consultorio.text_color)"
                :class="{
                  'badge-primary': consultorio.id === selectedConsultorioId,
                  'badge-secondary': consultorio.id !== selectedConsultorioId,
                }"
                class="consultorio-name"
              >
                {{ consultorio.nombre }}
              </span>
            </li>
          </ul>
        </div>

        <!-- Seccion dias bloqueados compacta -->
        <div class="mt-3">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 6px;
            "
          >
            <span class="especialidades-title" style="margin-bottom: 0"
              >BLOQUEADOS</span
            >
            <button
              @click="modalBloqueo = true"
              style="
                font-size: 10px;
                background: #e74c3c;
                color: white;
                border: none;
                border-radius: 4px;
                padding: 3px 7px;
                cursor: pointer;
              "
            >
              + Agregar
            </button>
          </div>

          <div
            v-if="diasBloqueados.length === 0"
            style="
              font-size: 10px;
              color: #999;
              text-align: center;
              padding: 4px;
            "
          >
            Sin días bloqueados
          </div>
          <div
            v-for="(dia, index) in diasBloqueados"
            :key="index"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 3px 6px;
              margin-bottom: 3px;
              background: #fff5f5;
              border: 1px solid #fdecea;
              border-radius: 4px;
            "
          >
            <div>
              <span style="font-size: 10px; font-weight: bold">{{
                dia.fecha
              }}</span>
              <span
                v-if="dia.motivo"
                style="font-size: 9px; color: #888; display: block"
                >{{ dia.motivo }}</span
              >
            </div>
            <button
              @click="desbloquearDia(dia.id)"
              style="
                font-size: 9px;
                color: #e74c3c;
                background: none;
                border: none;
                cursor: pointer;
                white-space: nowrap;
              "
            >
              Quitar
            </button>
          </div>
        </div>
      </div>

      <div class="field col-12 md:col-10">
        <FullCalendar
          :options="calendarOptions"
          :events="events"
          style="font-size: 12px"
        />
        <NuevaCita
          :show="nuevaCitaDialog"
          :cita="cita"
          :consultorios="consultorios"
          :medicos="medicos"
          :medicoLogueado="medicoLogueado"
          @closeModal="ocultarDialog()"
          @actualizarListado="obtenerListadoAgenda()"
        />
      </div>
    </div>
  </div>

  <!-- Modal bloqueo de dia -->
  <Dialog
    v-model:visible="modalBloqueo"
    header="Bloquear día"
    :modal="true"
    :style="{ width: '320px' }"
    :closable="true"
  >
    <div class="p-fluid">
      <div class="field">
        <strong>Fecha:</strong>
        <input
          type="date"
          v-model="nuevoDiaBloqueado.fecha"
          class="p-inputtext p-component w-full"
          style="font-size: 12px"
        />
      </div>
      <div class="field mt-2">
        <strong>Motivo (opcional):</strong>
        <input
          type="text"
          v-model="nuevoDiaBloqueado.motivo"
          placeholder="Ej: Feriado, Mantenimiento..."
          class="p-inputtext p-component w-full"
          style="font-size: 12px"
        />
      </div>
    </div>
    <template #footer>
      <Button
        @click="modalBloqueo = false"
        label="CANCELAR"
        class="p-button-secondary"
      />
      <Button
        @click="bloquearDia"
        icon="pi pi-lock"
        class="p-button-danger"
        label="BLOQUEAR"
      />
    </template>
  </Dialog>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import NuevaCita from "@/module/agenda/NuevaCita.vue";
import AgendaService from "@/service/AgendaService";
import MedicoService from "@/service/MedicoService";
import { useAuth } from "@/stores";

export default {
  components: {
    FullCalendar,
    NuevaCita,
  },
  data() {
    return {
      nuevaCitaDialog: false,
      modalBloqueo: false,
      cita: {
        id: null,
        medico_id: null,
        nombre_medico: null,
        consultorio_id: null,
        nombre_consultorio: null,
        cliente_id: null,
        nombre_cliente: null,
        detalle: null,
        fecha_inicio: null,
        fecha_fin: null,
        duracion: null,
        color: null,
        textColor: null,
        estado: null,
      },
      agendas: [],
      loading: false,
      events: [],
      consultorios: [],
      medicos: [],
      medicoLogueado: false,
      medicoSelected: 0,
      agendasFiltradas: [],
      selectedConsultorioId: null,
      colorConsultorio: "#007dd7",
      diasBloqueados: [],
      ultimoRangoCargado: null,
      nuevoDiaBloqueado: { fecha: null, motivo: "" },
    };
  },
  agendaService: null,
  medicoService: null,
  auth: null,

  created() {
    this.agendaService = new AgendaService();
    this.medicoService = new MedicoService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarMedicos();
    this.cargarDiasBloqueados();
    // obtenerListadoAgenda se llama desde onDatesSet al inicializar el calendario
  },
  computed: {
    calendarOptions() {
      return {
        datesSet: this.onDatesSet,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "timeGridDay",
        locales: [esLocale],
        buttonText: {
          today: "Hoy",
          week: "Semana",
          day: "Día",
        },
        nowIndicator: true,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        slotMinTime: "08:00:00",
        slotMaxTime: "20:00:00",
        slotLabelFormat: {
          hour: "numeric",
          minute: "2-digit",
          meridiem: "short",
        },
        height: "auto",
        allDaySlot: false,
        selectable: true,
        selectMirror: true,
        dateClick: this.agregarCita,
        eventClick: this.agregarCita,
        events: this.agendasFiltradas.map((agenda) => {
          let bgColor = agenda.color;
          let textColor = agenda.text_color || "#ffffff";

          if (agenda.estado === 0) {
            // Eliminada - rojo
            bgColor = "#e74c3c";
            textColor = "#ffffff";
          } else if (agenda.estado === 2) {
            // No atendida - amarillo
            bgColor = agenda.color || "#FFD700";
            textColor = agenda.text_color || "#000000";
          }

          return {
            id: agenda.id,
            title: `${agenda.nombre_cliente} - ${agenda.nombre_medico} - ${
              agenda.nombre_consultorio
            } - ${agenda.detalle || ""}`,
            start: agenda.fecha_inicio,
            end: agenda.fecha_fin,
            backgroundColor: bgColor,
            textColor: textColor,
            extendedProps: {
              detalle: agenda.detalle,
              cliente_id: agenda.cliente_id,
              telefono: agenda.telefono,
              medico_id: agenda.medico_id,
              consultorio_id: agenda.consultorio_id,
              estado: agenda.estado,
            },
          };
        }),
        eventDidMount: function (info) {
          let view = info.view.type;
          if (view === "timeGridDay") {
            info.el.style.fontSize = "12px";
          } else if (view === "timeGridWeek") {
            info.el.style.fontSize = "10px";
          } else if (view === "dayGridMonth") {
            info.el.style.fontSize = "9px";
          }
          info.el.style.fontWeight = "600";
        },
        selectAllow: (selectInfo) => {
          const fecha = selectInfo.startStr.split("T")[0];
          return !this.diasBloqueados.some((d) => d.fecha === fecha);
        },
        dayCellDidMount: (info) => {
          // Pintar dias bloqueados con fondo rosado en vistas mes y semana
          const fecha = info.date.toISOString().split("T")[0];
          const bloqueado = this.diasBloqueados.find((d) => d.fecha === fecha);
          if (bloqueado) {
            info.el.style.backgroundColor = "#fdecea";
            info.el.style.cursor = "not-allowed";
          }
        },
      };
    },
  },
  methods: {
    cargarDiasBloqueados() {
      this.agendaService.getDiasBloqueados().then((data) => {
        this.diasBloqueados = data.dias_bloqueados || [];
      });
    },

    bloquearDia() {
      if (!this.nuevoDiaBloqueado.fecha) {
        this.$toast.add({
          severity: "warn",
          summary: "Atención",
          detail: "Selecciona una fecha",
          life: 3000,
        });
        return;
      }
      this.agendaService.bloquearDia(this.nuevoDiaBloqueado).then((data) => {
        if (data.success) {
          this.$toast.add({
            severity: "success",
            summary: "Listo",
            detail: data.message,
            life: 3000,
          });
          this.nuevoDiaBloqueado = { fecha: null, motivo: "" };
          this.modalBloqueo = false;
          this.cargarDiasBloqueados();
          this.ultimoRangoCargado = null;
          this.obtenerListadoAgenda();
        } else {
          this.$toast.add({
            severity: "warn",
            summary: "Aviso",
            detail: data.message,
            life: 3000,
          });
        }
      });
    },

    desbloquearDia(id) {
      this.agendaService.desbloquearDia({ id }).then((data) => {
        if (data.success) {
          this.$toast.add({
            severity: "success",
            summary: "Listo",
            detail: data.message,
            life: 3000,
          });
          this.cargarDiasBloqueados();
          this.ultimoRangoCargado = null;
          this.obtenerListadoAgenda();
        }
      });
    },

    onDatesSet(dateInfo) {
      const rangoActual = dateInfo.startStr + "_" + dateInfo.endStr;
      // Si el rango es el mismo que ya se cargo, no volver a pedir
      if (this.ultimoRangoCargado === rangoActual) return;
      this.ultimoRangoCargado = rangoActual;
      this.obtenerListadoAgenda(dateInfo.startStr, dateInfo.endStr);
    },

    mostrarAgenda(consultorio_id, color) {
      this.selectedConsultorioId = consultorio_id;
      this.colorConsultorio = color || "#007dd7";
      this.agendasFiltradas =
        consultorio_id === 0
          ? this.agendas
          : this.agendas.filter(
              (agenda) => agenda.consultorio_id === consultorio_id,
            );
    },

    obtenerListadoAgenda(fecha_inicio = null, fecha_fin = null) {
      try {
        this.loading = true;
        this.agendaService
          .obtenerListadoAgenda({ fecha_inicio, fecha_fin })
          .then((data) => {
            this.agendas = data.agendas || [];
            this.consultorios = data.consultorios || [];

            this.consultorios.unshift({
              id: 0,
              nombre: "TODOS",
              direccion: "TODOS",
            });

            if (this.consultorios.length > 0) {
              if (this.consultorios.length === 2) {
                this.selectedConsultorioId = this.consultorios[1].id;
                this.colorConsultorio = this.consultorios[1].text_color;
              } else {
                this.selectedConsultorioId =
                  this.selectedConsultorioId || this.consultorios[0].id;
                this.colorConsultorio =
                  this.colorConsultorio || this.consultorios[0].text_color;
              }
            }

            this.loading = false;
            this.mostrarAgenda(
              this.selectedConsultorioId,
              this.colorConsultorio,
            );
          });
      } catch (error) {
        console.log(error);
      }
    },

    ocultarDialog() {
      this.nuevaCitaDialog = false;
    },

    agregarCita(info) {
      if (info.event) {
        this.editarCita(info.event);
        return;
      }
      if (!info.dateStr) return;
      if (info.dateStr.split("T").length < 2) return;

      // Verificar si el dia esta bloqueado
      const fechaSeleccionada = info.dateStr.split("T")[0];
      const bloqueado = this.diasBloqueados.find(
        (d) => d.fecha === fechaSeleccionada,
      );
      if (bloqueado) {
        this.$toast.add({
          severity: "warn",
          summary: "Día bloqueado",
          detail: bloqueado.motivo
            ? `No disponible: ${bloqueado.motivo}`
            : "Este día no está disponible para agendar",
          life: 4000,
        });
        return;
      }

      const fecha = info.dateStr.split("T")[0].split("-").reverse().join("/");
      const hora = info.dateStr.split("T")[1].substring(0, 5);
      const duracion = 30;
      const color = this.colorConsultorio;
      const medico_id = this.medicoSelected;
      const consultorio_id = this.selectedConsultorioId;
      this.cita = {
        fecha,
        hora,
        duracion,
        color,
        medico_id,
        consultorio_id,
      };

      this.nuevaCitaDialog = true;
    },

    editarCita(event) {
      if (!event) return;
      const extendedProps = event.extendedProps || {};
      this.cita = {
        id: event.id,
        fecha: event.startStr.split("T")[0].split("-").reverse().join("/"),
        hora: event.startStr.split("T")[1].substring(0, 5),
        duracion: (new Date(event.end) - new Date(event.start)) / 60000,
        textColor: extendedProps.textColor,
        color: this.colorConsultorio,
        detalle: extendedProps.detalle || "",
        cliente_id: extendedProps.cliente_id || null,
        nombre_cliente: event.title.split(" - ")[0],
        telefono: extendedProps.telefono || null,
        convenio: extendedProps.convenio || null,
        medico_id: extendedProps.medico_id || null,
        nombre_medico: event.title.split(" - ")[1],
        consultorio_id: extendedProps.consultorio_id || null,
        nombre_consultorio: event.title.split(" - ")[2] || "",
        estado: extendedProps.estado || null,
      };
      this.nuevaCitaDialog = true;
    },

    cargarMedicos() {
      this.medicoService.getMedicosAll().then((data) => {
        this.medicos = data.medicos || [];
        if (this.medicos.length > 0) {
          let medico = this.medicos.find(
            (medico) => medico.nombre_completo === this.auth.user.name,
          );
          if (medico) {
            this.medicoSelected = medico.id;
            this.medicoLogueado = true;
          } else {
            this.medicoSelected = 0;
            this.medicos.unshift({ id: 0, nombre_completo: "TODOS" });
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

ul {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
}

.badge-primary {
  background-color: #000000;
  color: white;
  border: 1px solid #000000;
}

.badge-secondary {
  background-color: white;
  color: #000000;
  border: 1px solid #000000;
}

.especialidades-title {
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  display: block;
  margin-bottom: 10px;
  color: #333;
}

.planta-title {
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  display: block;
  margin-bottom: 5px;
  color: #555;
}

.consultorio-item {
  list-style: none;
  margin: 5px 0;
}

.consultorio-name {
  display: flex;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 5px;
  border: 2px solid #ddd;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}
</style>
